import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import Swal from 'sweetalert2';
import { RoleService } from './role.service';
import { RoleDialogComponent } from './role-dialog/role-dialog.component';
import { PermissionDialogComponent } from './permission-dialog/permission-dialog.component'; // 👈 import this


@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss'],
})
export class RolesComponent implements OnInit {
  displayedColumns: string[] = ['name',  'actions'];
  dataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private roleService: RoleService, private dialog: MatDialog) {}

  ngOnInit() {
    this.loadRoles();
  }

  loadRoles() {
    Swal.fire({
      title: 'Loading Roles...',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    this.roleService.getRoles().subscribe({
      next: (data) => {
        Swal.close();
        this.dataSource.data = data;
        if (this.paginator) this.dataSource.paginator = this.paginator;
      },
      error: () => {
        Swal.close();
        Swal.fire('Error', 'Failed to load roles', 'error');
      },
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  openRoleDialog(role?: any) {
    const dialogRef = this.dialog.open(RoleDialogComponent, {
      width: '500px',
      maxWidth: '95vw',
      panelClass: 'app-modal-panel',
      backdropClass: 'app-modal-backdrop',
      data: role ? { ...role } : null,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Role saved successfully!',
          confirmButtonText: 'OK',
        }).then(() => {
          this.loadRoles();
        });
      }
    });
  }

  deleteRole(id: string) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This will permanently delete the role!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Deleting...',
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading(),
        });

        this.roleService.deleteRole(id).subscribe({
          next: () => {
            Swal.close();
            Swal.fire('Deleted!', 'Role deleted successfully.', 'success');
            this.loadRoles();
          },
          error: () => {
            Swal.close();
            Swal.fire('Error', 'Failed to delete role.', 'error');
          },
        });
      }
    });
  }
  openPermissionDialog() {
    const dialogRef = this.dialog.open(PermissionDialogComponent, {
      width: '450px',
      maxWidth: '95vw',
      panelClass: 'app-modal-panel',
      backdropClass: 'app-modal-backdrop',
    });
  
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        Swal.fire('Success', 'Permission created successfully!', 'success');
        this.loadRoles(); // reload if you want to reflect permission updates
      }
    });
  }
}
